<template>
  <!--  面板渲染
      @author: 王汝鹏
      @date: 2019-11-26
  -->
  <div class="render-free" v-if="isDisplay">
    <render-item-template v-for="(item) in formNode.children"
                          :key="item.id"
                          :formNode="item"></render-item-template>
  </div>
</template>


<script>
/** 混入方法 ::: 
 *  @mixin mixRenderItemTemplateChild 预览表单子级混入
 */
import { mixRenderItemTemplateChild } from "@/mixins/render_item/mix_render_item_template_child.js";


export default {
  mixins: [ mixRenderItemTemplateChild ],
};
</script>





// WEBPACK FOOTER //
// src/components/render_item/RenderFree.vue